import React from "react";
import { observer } from "mobx-react-lite";

import { translationService } from "../../../services/translation/TranslationService";
import { Undo } from "../../svg/svgImageList";
import Button from "../../button/Button";

interface UndoImageRemoval {
  onUndo(): void;
}

export default observer(function UndoImageRemoval({ onUndo }: UndoImageRemoval) {
  return (
    <div className="undo-remove-image">
      {translationService.translate("general.upload.initial-image.remove")}
      <Button
        id="remove"
        onClick={onUndo}
        icon={{
          svg: Undo,
          className: "undo-remove-icon-button",
        }}
      />
    </div>
  );
});
